import { useMemo } from 'react'

import { CustomFieldType } from '@tribeplatform/gql-client/types'
import {
  CONTENT_FIELD_KEY,
  TITLE_FIELD_KEY,
} from '@tribeplatform/react-components/CustomField'
import { useNetwork } from '@tribeplatform/react-sdk/hooks'

interface Props {
  postTypeSlugs: string[]
  postTypeId?: string
  excludeRichText?: boolean
  excludePrivateFields?: boolean
  excludeTitle?: boolean
}
export const useCustomFields = ({
  postTypeSlugs,
  postTypeId,
  excludeRichText = true,
  excludePrivateFields = true,
  excludeTitle = true,
}: Props) => {
  const {
    data: { postTypes },
  } = useNetwork()

  const customFields = useMemo(() => {
    if (!postTypes) {
      return []
    }

    if (postTypeId) {
      const postType = postTypes.find(postType => postType.id === postTypeId)
      if (!postType) {
        return []
      }

      return postType.postFields.fields.filter(
        field =>
          !field.archived &&
          field.key !== CONTENT_FIELD_KEY &&
          !(excludeTitle && field.key === TITLE_FIELD_KEY) &&
          !(excludeRichText && field.type === CustomFieldType.richText) &&
          !(excludePrivateFields && field?.readPrivacy?.allow?.length !== 0),
      )
    }

    if (postTypeSlugs.length !== 1) {
      return []
    }

    const [postTypeSlug] = postTypeSlugs
    const postType = postTypes.find(postType => postType.slug === postTypeSlug)
    if (!postType) {
      return []
    }

    return postType.postFields.fields.filter(
      field =>
        !field.archived &&
        field.key !== CONTENT_FIELD_KEY &&
        !(excludeTitle && field.key === TITLE_FIELD_KEY) &&
        !(excludeRichText && field.type === CustomFieldType.richText) &&
        !(excludePrivateFields && field?.readPrivacy?.allow?.length !== 0),
    )
  }, [
    excludePrivateFields,
    excludeRichText,
    excludeTitle,
    postTypeId,
    postTypeSlugs,
    postTypes,
  ])

  return { postTypes, customFields }
}
